module.exports = __webpack_public_path__ + "Server-Unknown.AzureServiceFabricCluster.4cdc2898c55d56aee9aa610cee1aad14.hashedasset.svg";